import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  PendingAgentSession,
  UserChatHistoryApiResponse,
  UserChatHistoryRequest,
  AcceptAgentRequest,
  AcceptAgentResponse,
  MessageReceivedRequest,
  ExitAgentRequest,
  WhatsAppActiveSessionsResponse
} from '../models/agent-lead-notification.model';

@Injectable({
  providedIn: 'root'
})
export class AgentLeadNotificationService {

  constructor(private http: HttpClient) {}

  getPendingAgentRequests(): Observable<PendingAgentSession> {
    return this.http.get<PendingAgentSession>(
      `${environment.apiUrl}Chat/GetPendingAgentRequests`
    );
  }

  getUserChatHistory(payload: UserChatHistoryRequest): Observable<UserChatHistoryApiResponse> {
    const params = new HttpParams()
      .set('Session_Id', payload.Session_Id)
      .set('MobileNumber', payload.MobileNumber);
    return this.http.get<UserChatHistoryApiResponse>(
      `${environment.apiUrl}Chat/GetUserChatHistory`,
      { params }
    );
  }

  acceptAgent(payload: AcceptAgentRequest): Observable<AcceptAgentResponse> {
    return this.http.post<AcceptAgentResponse>(`${environment.apiUrl}Chat/AcceptAgent`, payload);
  }

  messageReceived(payload: MessageReceivedRequest): Observable<any> {
    return this.http.post(`${environment.apiUrl}Chat/MessageReceived`, payload);
  }

  exitAgent(payload: ExitAgentRequest): Observable<any> {
    return this.http.post(`${environment.apiUrl}Chat/ExitAgent`, payload);
  }

  getWhatsAppActiveRequests(agentId: number): Observable<WhatsAppActiveSessionsResponse> {
    const params = new HttpParams().set('Agent_id', agentId.toString());
    return this.http.get<WhatsAppActiveSessionsResponse>(
      `${environment.apiUrl}Chat/GetWhatsAppActiveRequests`,
      { params }
    );
  }
}
